/** Maps Clerk user IDs in dev when the original doesn't exist in evals_user. */
const DEV_USER_ID_MAP: Record<string, string> = {
  user_2if8Wh567pp2QrJ4miTj3igPsXe: "user_2k52oq9zuKjlLZq4oqZEM93q2Km", //RHEA
  user_2yb42lrrDi0OCryI1kAiV68losE: "user_2yb5RlsGlyIgMxMnx4c8HW7QPAU", //LOREN
  user_2tp1acwtzBvzKOyAxRIXCfFms1d: "user_2touwvprnIOFbnpXroAoPFdsECt", //KOBI
  user_337FkbMkygP0YMODU9Msn2jjTV0: "user_32Vxe5ZZnIUQnhAk3B5e13GuWgo", //ROB
  user_38AhtEeBqwpAa9H9veJBCHU10bQ: "user_38B6qliZhwlSQ76VzGFhl1Gbk6G", //CALLUM
  user_37qcdoJUDwwU2zAAQXYMjxAx2j6: "user_37pH9uu4GueNR0STC8QyrtyOgI1", //OLIAD
  user_37wPrqLVbowKb81N2q4SWwvLOSj: "user_37wKOAF3ZGik5M0QcwjtRKmh9XO", //KARIS
  user_37wKOAF3ZGik5M0QcwjtRKmh9XO: "user_398Iq2eFj7W40JnD33Jwe0MJLDC", //DAKOTA
  user_2jLXRt4CV8pcaNnqcEhsuRF60bS: "user_2k5XrpKycPr1GGk8Hz8mbJoE1bQ", //BROOKE
  // "user_prod_xxx": "user_dev_yyy",
}

export function mapClerkUserId(
  clerk_user_id: string | undefined,
): string | undefined {
  if (clerk_user_id === undefined || clerk_user_id === null || !clerk_user_id) {
    return undefined
  }
  if (
    process.env.NODE_ENV === "development" &&
    DEV_USER_ID_MAP[clerk_user_id]
  ) {
    return DEV_USER_ID_MAP[clerk_user_id]
  }
  return clerk_user_id
}
